<template>
  <div class="ls-box-filter ls-no-margin-bottom">
    <form class="ls-form ls-form-horizontal row">
      <fieldset>
        <div class="col-md-12">
          <label class="ls-label col-lg-4 col-xlg-4 col-md-4 col-xs-12">
            <b class="ls-label-text">{{ $t('orders.attributes.customer') }}</b>
            <input type="text" v-model="search_customer_name" :placeholder="$t('invoices.attributes.customer')">
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('orders.filter.contract_code')}}</b>
            <input type="text" v-model="search_contract_code" placeholder="Ex.: Abc123">
          </label>

          <label class="ls-label col-lg-2 col-xlg-2 col-md-2 col-xs-12">
            <b class="ls-label-text">{{ $t('orders.filter.invoice_id')}}</b>
            <input type="number" min="1" v-model="search_invoice_id" placeholder="1">
          </label>


          <label class="ls-label col-lg-3 col-md-3 col-xlg-2 col-xs-12">
            <b class="ls-label-text">{{ $t('invoices.attributes.status') }}</b>
            <div class="ls-custom-select">
              <select v-model="search_status" class="ls-select">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="4">{{ $t('orders.status.reversed') }}</option>
                <option value="3">{{ $t('orders.status.paid') }}</option>
                <option value="2">{{ $t('orders.status.not_paid') }}</option>
                <option value="1">{{ $t('orders.status.pending') }}</option>
              </select>
            </div>
          </label>

          <div class="btn-action">
            <button type="button" class="ls-btn-danger ls-no-margin-bottom" @click="clearFilters" @keyup.enter="clearFilters">
              <i class="fa fa-eraser" aria-hidden="true"></i>
              <span>{{ $t('application.filter.clear_filters') }}</span>
            </button>
            <button type="button" class="ls-btn ls-no-margin-bottom" v-on:click="searchOrders">
              <i class="fa fa-search" aria-hidden="true"></i>
              <span>{{ $t('application.filter.filter') }}</span>
            </button>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="column is-5">
    </div>
  </div>
</template>
<script>
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'

export default {
  data () {
    return {
      search_contract_code: '',
      search_customer_name: '',
      search_status: '',
      search_invoice_id: '',
      filters_selecteds: []
    }
  },
  mounted () {
    this.populateData()
    this.$parent.$on('clearFilters', this.clearFilters)
  },
  methods: {
    searchOrders () {
      this.$store.commit(setPagination, { per_page: 10, current_page: 1 })
      this.applyFilter()
      this.$parent.loadOrders()
    },
    applyFilter () {
      this.$parent.filters = []
      this.attributes().map((key) => {
        if (this[key]) {
          this.$parent.filters[this.findKey(key)] = this[key]
        }
      })
    },
    populateData () {
      this.search_contract_code = !this.$route.query['orders[contract][code]'] ? '' : this.$route.query['orders[contract][code]']
      this.search_customer_name = !this.$route.query['orders[customer][name]'] ? '' : this.$route.query['orders[customer][name]']
      this.search_status = !this.$route.query['orders[status]'] ? '' : this.$route.query['orders[status]']
      this.search_invoice_id = !this.$route.query['orders[invoice][id]'] ? '' : this.$route.query['orders[invoice][id]']
    },
    findKey (key) {
      switch (key) {
        case 'search_contract_code': return 'orders[contract][code]'
        case 'search_customer_name': return 'orders[customer][name]'
        case 'search_status': return 'orders[status]'
        case 'search_invoice_id': return 'orders[invoice][id]'
      }
    },
    clearFilters () {
      this.$parent.filters = []
      this.attributes().map((key) => {
        this[key] = ''
      })
      this.searchOrders()
    },
    attributes () {
      return ['search_contract_code', 'search_customer_name', 'search_status', 'search_invoice_id']
    }
  }
}
</script>
<style scoped>
label.ls-label-text span {
  position: relative;
  top: -12px;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// Filter.vue?33d3f632